fx.ns("shared.extractors", class InstagramExtractor extends shared.MediaExtractor {

    constructor(parameters)
    {
        super(parameters);

    }

    process(files)
    {
        this._queueFiles = this._queueFiles.concat(files);

        this._processQueue();
    }

    _processQueue()
    {
        if (this._queueFiles.length > 0)
        {
            this.currentFile = this._queueFiles.shift();
    
            this.currentFile.image = new Image();
            this.currentFile.image.setAttribute("crossorigin","anonymous"); // added in order to avoid => "Failed to execute 'toDataURL' on 'HTMLCanvasElement': Tainted canvases may not be exported."
            this.currentFile.image.onload = this.onLoaded.bind(this);
    
            this.currentFile.image.src = this.currentFile.thumb;
        }
    }

    onLoaded()
    {
        this._createPhoto();
    }

    _createPhoto()
    {
        let date = new Date();

        let newWidth1 = this.thumbSize;
        let newHeight1 = newWidth1 * this.currentFile.image.height / this.currentFile.image.width;
        let dataImg = fx.graphics.imageToDataUri(this.currentFile.image, newWidth1, newHeight1); 
        let luminance = fx.graphics.getImageLuminance(this.currentFile.image, newWidth1, newHeight1);

        let photo = new models.Photo({
            bookid : this.data.creation.id,
            accountid : this.data.creation.accountid,
            thumb : dataImg,
            width :  this.currentFile.image.width,
            height :  this.currentFile.image.height,
            orientation : 0,
            date_SQL : date.toSQL(),
            date_unix : date.getUnixTime(),
            date_taken_unix : date.getUnixTime(),
            date_takenSQL : date.toSQL(),
            number : 0,
            average_color : luminance
        });

        photo.prop("thumbWidth", newWidth1);
        photo.prop("thumbHeight", newHeight1);
        photo.prop("social", "instagram");
        photo.prop("media_url", this.currentFile.thumb);
        photo.prop("base64", photo.thumb);
        photo.prop("date", date);
        photo.prop("date_taken",  date );
        photo.prop("file", this.currentFile); 
        //photo.prop("memory", this.currentFile.image); // you need to have your image loaded in new Image()

        this.data.photos.addItem(photo);

        this.trigger("photo-extracted", photo);

        this._processQueue();
    }
   
});